import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AuthenticatedUser, Patient } from 'src/app/core/models';
import { PatientState } from 'src/app/core/store/patient/patient.state';
import { ApiStoreData } from 'src/app/core/store/utils';
import { Gtag } from 'angular-gtag';
import { UserState } from 'src/app/core/store/user/user.state';
import { SignOut, SwitchPatient } from 'src/app/core/store/user/user.actions';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent {
  @Select(UserState.isAgentUser) isAgentUser$!: Observable<boolean>;
  @Select(PatientState.patient) patient$!: Observable<Patient | null>;
  @Select(PatientState.patientsState) patients$!: Observable<ApiStoreData<Patient[]>>;
  @Select(PatientState.selectedPatientIndex) selectedPatientIndex$!: Observable<number | null>;
  @Select(UserState.authenticatedUser) authenticatedUser$!: Observable<AuthenticatedUser | null>;

  @Input() isDesktop!: boolean;

  userMenuVisible: boolean = false;
  switchPatientMenuVisible: boolean = false;

  @HostListener('document:click', ['$event'])
  click(event: PointerEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.userMenuVisible = false;
    }
  }

  constructor(private store: Store, private gtag: Gtag, private eRef: ElementRef) {}

  toggleSwitchPatientMenu() {
    this.switchPatientMenuVisible = !this.switchPatientMenuVisible;
  }

  toggleUserMenu() {
    this.userMenuVisible = !this.userMenuVisible;
  }

  switchPatient(pId: number) {
    const patientSwitched = new Subject<void>();

    this.patient$.pipe(takeUntil(patientSwitched)).subscribe((p) => {
      if (!!p && p.id === pId) return;

      this.switchPatientMenuVisible = false;
      this.userMenuVisible = false;
      patientSwitched.next();
      this.store.dispatch(new SwitchPatient(pId));
    });
  }

  signOut() {
    this.switchPatientMenuVisible = false;
    this.userMenuVisible = false;

    console.log('401 Logging: Initiating User SignOut from user menu...');
    this.store.dispatch(new SignOut());
    this.gtag.event('log_out', {
      event_category: 'engagement',
    });
  }
}
